import React, { Dispatch, FC, SetStateAction } from 'react';
import i18next from 'i18next';
import { parsePriceByCurrency } from '../../../../config/utils/currencyUtils';
import { Currency } from '../../../../models/Currency';
import { useStyles } from './styles';

interface Props {
    mobileNav: boolean;
    setModalBuyEvent: Dispatch<SetStateAction<boolean>>;
    inAppBrowse: boolean;
    num_tickets_free: number;
    event_price: number;
    currency: Currency;
    marginTop?: number;
}

const BuyButton: FC<Props> = ({
    mobileNav,
    setModalBuyEvent,
    inAppBrowse,
    num_tickets_free,
    event_price,
    currency,
    marginTop,
}) => {
    const classes = useStyles();

    return (
        <button
            type="button"
            style={{ position: mobileNav && !inAppBrowse ? 'fixed' : 'relative', marginTop }}
            disabled={num_tickets_free === 0}
            className={classes.button}
            onClick={() => setModalBuyEvent(true)}
        >
            {num_tickets_free > 0 &&
                parseFloat(event_price.toString()) > 0 &&
                `${i18next.t('EventPageComponentBuyTicketFor')} ${parsePriceByCurrency(
                    event_price.toString(),
                    currency,
                )}`}
            {num_tickets_free > 0 &&
                parseFloat(event_price.toString()) === 0 &&
                i18next.t('EventPageComponentBuyTicketForFree')}

            {num_tickets_free === 0 && i18next.t('EventPageComponentSorryEventSoldOut')}
        </button>
    );
};

export default BuyButton;
